export const NO_ACCESS_PATH = '/no-access';
export const NO_ACCESS_FROM_PARAM = 'from';

const RETURN_TO_KEY = 'gorko-no-access-return-to';

const getOrigin = () =>
	typeof window === 'undefined' ? 'http://localhost' : window.location.origin;

export const getLocationPath = (value) => {
	try {
		if (!value) {
			return '';
		}

		if (typeof value === 'string') {
			const url = new URL(value, getOrigin());

			return `${url.pathname}${url.search}${url.hash}`;
		}

		if (typeof value.url === 'string') {
			const url = new URL(value.url, getOrigin());

			return `${url.pathname}${url.search}${url.hash}`;
		}

		if (typeof value.pathname === 'string') {
			return `${value.pathname}${value.search ?? ''}${value.hash ?? ''}`;
		}
	} catch {
		return '';
	}

	return '';
};

const isSafeReturnPath = (path) =>
	Boolean(path) &&
	path.startsWith('/') &&
	!path.startsWith('//') &&
	!path.startsWith(NO_ACCESS_PATH);

const rememberReturnTo = (path) => {
	if (!isSafeReturnPath(path)) {
		return;
	}

	try {
		sessionStorage.setItem(RETURN_TO_KEY, path);
	} catch {
		// private mode / disabled storage
	}
};

const readStoredReturnTo = () => {
	try {
		return sessionStorage.getItem(RETURN_TO_KEY) ?? '';
	} catch {
		return '';
	}
};

export const buildNoAccessPath = (from) => {
	const path = getLocationPath(from);

	rememberReturnTo(path);

	if (!isSafeReturnPath(path)) {
		return NO_ACCESS_PATH;
	}

	return `${NO_ACCESS_PATH}?${new URLSearchParams({
		[NO_ACCESS_FROM_PARAM]: path,
	}).toString()}`;
};

export const getSafeReturnPath = (from) => {
	let path = '';

	try {
		if (from && typeof from === 'object' && typeof from.url === 'string') {
			path = new URL(from.url, getOrigin()).searchParams.get(
				NO_ACCESS_FROM_PARAM,
			);
		} else if (from?.href) {
			path = new URL(from.href, getOrigin()).searchParams.get(
				NO_ACCESS_FROM_PARAM,
			);
		} else if (typeof from === 'string') {
			path = new URL(from, getOrigin()).searchParams.get(
				NO_ACCESS_FROM_PARAM,
			);
		} else if (from?.search) {
			path = new URLSearchParams(from.search).get(NO_ACCESS_FROM_PARAM);
		}
	} catch {
		path = '';
	}

	if (isSafeReturnPath(path ?? '')) {
		return path;
	}

	path = readStoredReturnTo();

	return isSafeReturnPath(path) ? path : '/';
};
